import * as sitePath from '@/utils/function/sitePath';
import type { IFooterLinkItem } from './components/FooterLinkGroups';
import React from 'react';
import type { ISupportCountryItem } from '@/common';

export const productCategoryLinks: IFooterLinkItem[] = [
    {
        key: '16mp-security-camera',
        link: sitePath.getOfficialSitePath('/16mp-security-camera'),
    },
    {
        key: 'battery-security-cameras',
        link: sitePath.getStorePath('/battery-security-cameras'),
    },
    {
        key: 'dual-lens-cameras',
        link: sitePath.getStorePath('/dual-lens-cameras'),
    },
    {
        key: 'poe-ip-cameras',
        link: sitePath.getStorePath('/poe-ip-cameras'),
    },
    {
        key: 'wifi-security-cameras',
        link: sitePath.getStorePath('/wifi-security-cameras'),
    },
    {
        key: 'security-camera-systems',
        link: sitePath.getStorePath('/security-camera-systems'),
    },
    {
        key: 'video-doorbells',
        link: sitePath.getStorePath('/video-doorbells'),
    },
    {
        key: 'solution-finder',
        link: sitePath.getOfficialSitePath('/solution-finder'),
        strong: true,
    },
];

export const supportLinks: IFooterLinkItem[] = [
    {
        key: 'support-center',
        link: sitePath.getSupportPath('/'),
    },
    {
        key: 'blog',
        link: sitePath.getOfficialSitePath('/blog'),
    },
    {
        key: '3rd-party-compatibility',
        link: sitePath.getOfficialSitePath('/3rd-party-compatibility'),
    },
    {
        key: 'payment-methods',
        link: sitePath.getOfficialSitePath('/payment-methods'),
    },
    {
        key: 'warranty-and-return',
        link: sitePath.getOfficialSitePath('/warranty-and-return'),
    },
    {
        key: 'shipping-and-delivery',
        link: sitePath.getOfficialSitePath('/shipping-and-delivery'),
    },
    {
        key: 'track-your-order',
        link: sitePath.getOfficialSitePath('/track-your-order'),
    },
    {
        key: 'product-registration',
        link: sitePath.getOfficialSitePath('/product-registration'),
    },
    {
        key: 'report-an-issue',
        link: sitePath.getOfficialSitePath('/report-an-issue'),
    },
    {
        key: 'purchase-faqs',
        link: sitePath.getSupportPath('/hc/en-us/categories/360000280514-Orders-Payment'),
        strong: true,
        target: '_blank',
    },
];

export const companyLinks: IFooterLinkItem[] = [
    {
        key: 'about-us',
        link: sitePath.getOfficialSitePath('/about-us'),
    },
    {
        key: 'security',
        link: sitePath.getOfficialSitePath('/security'),
    },
    {
        key: 'share-captured-videos',
        link: sitePath.getOfficialSitePath('/share-captured-videos'),
    },
    {
        key: 'press',
        link: sitePath.getOfficialSitePath('/press'),
    },
    {
        key: 'contact-us',
        link: sitePath.getOfficialSitePath('/contact-us'),
    },
];

export interface IFooterContext {
    lang: string;
    country: string;
    countryTitle?: string;
    getTextByKey: (key: string) => string;
    countryList: ISupportCountryItem[];
    isEuCountry: boolean;
    isDistributor: boolean;
}

export const FooterContext = React.createContext<IFooterContext>({
    lang: 'en',
    country: '_',
    countryTitle: '',
    getTextByKey: (key: string) => key,
    countryList: [],
    isEuCountry: false,
    isDistributor: false,
});

/**
 * 社交媒体链接
 */
export const socialLinkItems = [
    {
        link: 'https://www.facebook.com/ReolinkTech/',
        key: 'facebook',
        icon: 'icon-icon_facebook-4',
    },
    {
        link: 'https://twitter.com/ReolinkTech',
        key: 'twitter',
        icon: 'icon-icon_twitter-4',
    },
    {
        link: 'https://www.youtube.com/channel/UCEHKZX6fFVtWd4tnnRkzrMA',
        key: 'youtube',
        icon: 'icon-icon_youtube-4',
    },
    {
        link: 'https://www.instagram.com/reolinkcams/',
        key: 'instagram',
        icon: 'icon-icon_ins-4',
    },
    {
        link: 'https://www.reddit.com/r/reolinkcam/',
        key: 'reddit',
        icon: 'icon-icon-reddit',
    },
];

export const getIsEuCountry = (countryList: ISupportCountryItem[], countryCode: string): boolean => {
    for (const continent of countryList) {
        if (continent.continentCode === 'EU') {
            return continent.countryList.some((item) => {
                return item.value === countryCode;
            });
        }
    }
    return false;
};
